import { RouterProvider } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import ScrollTop from 'components/ScrollTop';
import Toaster from 'components/Toaster';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Set document direction and language on mount and when language changes
    document.dir = i18n.language === 'fa' ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <ThemeCustomization>
      <ScrollTop>
        <Toaster />
        <RouterProvider router={router} />
      </ScrollTop>
    </ThemeCustomization>
  );
}
